import { getCookieData } from "./CommonFunction";

const getHeaders = (isForm, headers) => {
  let token;
  const user = getCookieData("user_info");
  if (user && user.token) {
    token = user.token;
  }
  let contentType;
  // Test with true and false because isForm can be undefined where we don't set any content type.
  if (isForm === false) {
    contentType = { "Content-type": "application/json; charset=UTF-8" };
  } else if (isForm === true) {
    contentType = { "Content-type": "application/x-www-form-urlencoded" };
  }
  return {
    ...headers,
    ...contentType,
    Authorization: `Bearer ${token}`,
    SystemKey: process.env.REACT_APP_SYSTEM_KEY,
  };
};

async function handleResponse(request) {
  try {
    const res = await request;
    if (res.ok) return await res.json();
    else return null;
  } catch (err) {
    return null;
  }
}

async function getApi(url, headers) {
  return handleResponse(
    fetch(url, {
      method: "get",
      headers: getHeaders(undefined, headers),
    })
  );
}

async function postApi(url, body, isForm, headers) {
  return handleResponse(
    fetch(url, {
      method: "post",
      headers: getHeaders(isForm, headers),
      body: isForm ? body : JSON.stringify(body),
    })
  );
}

export { getApi, postApi, getHeaders };
